var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50065 13.1667V14C5.50065 14.663 5.76404 15.2989 6.23288 15.7678C6.70172 16.2366 7.33761 16.5 8.00065 16.5C8.66369 16.5 9.29958 16.2366 9.76842 15.7678C10.2373 15.2989 10.5007 14.663 10.5007 14V13.1667M6.33398 3.16667C6.33398 2.72464 6.50958 2.30072 6.82214 1.98816C7.1347 1.67559 7.55862 1.5 8.00065 1.5C8.44268 1.5 8.8666 1.67559 9.17916 1.98816C9.49172 2.30072 9.66732 2.72464 9.66732 3.16667C10.6243 3.61919 11.4402 4.32361 12.0274 5.20442C12.6146 6.08523 12.951 7.10923 13.0007 8.16667V10.6667C13.0634 11.1848 13.2468 11.6809 13.5363 12.1151C13.8258 12.5493 14.2132 12.9095 14.6673 13.1667H1.33398C1.7881 12.9095 2.17549 12.5493 2.46497 12.1151C2.75446 11.6809 2.93794 11.1848 3.00065 10.6667V8.16667C3.05028 7.10923 3.38674 6.08523 3.97394 5.20442C4.56115 4.32361 5.37698 3.61919 6.33398 3.16667Z",
    stroke: "#5D6165",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell_icon.3a465d9eb830351616ed58dbb12a4a26.svg";